// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"c7355821","384":"8d1a0aad","875":"5bb07cc5","915":"c7355821"}[chunkId] + ".chunk.css";
};